import React from "react";
import { Layout as LayoutDefault, Loader, Meta } from "@sicredi/react";
import "./styles.scss";
import { useIsAuthenticated } from "#/hooks/useIsAuthenticated";
import {
  Breadcrumb,
  PreviousPage,
  PageInfo,
  Navbar,
  BackButton,
} from "./components";
import ResponsiveSpacing from "../ResponsiveSpacing";
import { LayoutPropsBase } from "./config";
import { GlobalContext } from "#/context/Global";

export const Layout: React.FC<LayoutPropsBase> = ({
  pageInfo,
  breadcrumpConfig,
  children,
  isLoading = true,
  hasActionButtons = false,
}) => {
  const { user } = useIsAuthenticated();
  const backUrl = breadcrumpConfig.previousPages.slice(-1)[0] as PreviousPage;
  const { state } = GlobalContext();

  return (
    <LayoutDefault className="layout">
      <Meta title={pageInfo.title} />

      <LayoutDefault.Container className="container">
        <LayoutDefault.Content className="content">
          <Loader
            data-testid="loader"
            show={isLoading || state.isLoading}
            fullScreen
          />

          {user ? <Navbar /> : null}

          <Breadcrumb {...breadcrumpConfig} />

          <ResponsiveSpacing
            appearanceDesktop="x-large"
            appearanceMobile="medium"
          />

          <PageInfo {...pageInfo} />

          {children}

          {!hasActionButtons && <BackButton backUrl={backUrl.to} />}
        </LayoutDefault.Content>
      </LayoutDefault.Container>
    </LayoutDefault>
  );
};
